import { Field, Formik } from "formik";
import React from "react";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { postAnswer } from "../../../api/api";
import arrow_left_gray from "../../../assets/images/icons/arrow_left_gray.svg";
import arrow_right_white from "../../../assets/images/icons/arrow_right_white.svg";
import { Notify } from "../../../utils/notify";

export default function Question({ question, prevStep, nextStep, number, anonymousToken }) {
    const { token } = useParams();
    const { email } = useParams();
    const answerMutation = useMutation((values) => postAnswer(values));
    const hasSubQuestions = question.sub_questions && question.sub_questions.length > 0;
    const questions = [question, ...(question.sub_questions || [])];

    let stepperGoTo = question.go_to_question_id ?? number + 1;

    const onSubmit = (values, { setSubmitting, setErrors, resetForm }) => {
        let copyValues = structuredClone(values);
        copyValues.answers = Object.entries(copyValues.answers).reduce((acc, [key, answer]) => {
            if (Array.isArray(answer.value)) {
                answer.value = answer.value.join("|");
            }
            acc[key] = answer;
            return acc;
        }, {});
        copyValues.anonymous_token = anonymousToken;

        answerMutation.mutate(copyValues, {
            onSuccess: () => {
                nextStep(stepperGoTo);
                resetForm();
            },
            onError: (error) => {
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    if (error.response.status === 404) {
                        Notify.error("Er is iets fout gegaan, herlaad de pagina en probeer het opnieuw.", 5000);
                        setTimeout(() => {
                            window.location.reload();
                        }, 5500);
                    } else {
                        Notify.error("Er is iets fout gegaan, probeer het later nogmaals.");
                    }
                }
                setSubmitting(false);
            },
        });
    };

    const getQuestionTitle = (question) => {
        // Get element from html string (since we use wysiwyg editor)
        const baseTitle = new DOMParser().parseFromString(question.title, "text/html").querySelector("body").firstElementChild;

        if (question.is_required) {
            const requiredText = new DOMParser()
                .parseFromString(
                    "<span style='margin-left: 0.5em; margin-bottom: auto; color: #CBCBCB; font-size: 15px;'> (verplicht)</span>",
                    "text/html",
                )
                .querySelector("body").firstElementChild;
            // baseTitle.style.display = "inline-block";
            // baseTitle.style.verticalAlign = "top";

            baseTitle.append("*");
            baseTitle.append(requiredText);
        }

        return baseTitle.outerHTML;
    };

    const getOtherInputBlock = (type, question) => {
        return (
            <>
                <div className={type} key="other">
                    {type === "radio" ? (
                        <Field
                            id={`answers.${question.id}.other`}
                            name={`answers.${question.id}.value`}
                            type={type}
                            className="form-control"
                            value={"other"}
                            autoFocus={false}
                        />
                    ) : (
                        <Field
                            id={`answers.${question.id}.other`}
                            name={`answers.${question.id}.other`}
                            type={type}
                            className="form-control"
                            autoFocus={false}
                        />
                    )}
                    <label htmlFor={`answers.${question.id}.other`}>Anders, namelijk</label>
                </div>
                <Field className="form-control" name={`answers.${question.id}.other_value`} type="text" autoFocus={false} />
            </>
        );
    };

    const getInput = (question) => {
        switch (question.type) {
            case "multiple_choice":
                return (
                    <div className="mt-2">
                        {question.options.map((option, index) => (
                            <div className="radio" key={index}>
                                <Field
                                    name={`answers.${question.id}.value`}
                                    value={option.id}
                                    id={option.id}
                                    type="radio"
                                    className="form-control"
                                    onClick={() => (stepperGoTo = option.go_to ?? stepperGoTo)}
                                    autoFocus={false}
                                />
                                <label htmlFor={option.id}> {option.title} </label>
                            </div>
                        ))}
                        {question.has_other_option === 1 ? getOtherInputBlock("radio", question) : ""}
                    </div>
                );

            case "multiple_answer":
                return (
                    <div className="mt-2">
                        {question.options.map((option, index) => (
                            <div className="checkbox" key={index}>
                                <Field
                                    name={`answers.${question.id}.value`}
                                    value={option.id}
                                    id={option.id}
                                    type="checkbox"
                                    className="form-control"
                                    autoFocus={false}
                                />
                                <label htmlFor={option.id}> {option.title} </label>
                            </div>
                        ))}
                        {question.has_other_option === 1 ? getOtherInputBlock("checkbox", question) : ""}
                    </div>
                );
            default: //open
                return <Field name={`answers.${question.id}.value`} type="text" className="form-control" autoFocus={false} />;
        }
    };

    return (
        <div>
            <Formik
                initialValues={{
                    token: token,
                    email: email,
                    answers: questions.reduce((acc, q) => {
                        acc[q.id] = {
                            value: "",
                            other: "",
                            other_value: "",
                        };
                        return acc;
                    }, {}),
                }}
                onSubmit={onSubmit}
                enableReinitialize={true}
            >
                {({ errors, touched, handleSubmit, isSubmitting }) => (
                    <form onSubmit={handleSubmit}>
                        {questions &&
                            questions.map((question, index) => (
                                <div key={index} className={hasSubQuestions ? "sub-question-content" : "content"}>
                                    <div style={{ display: "flex" }}>
                                        <h1 className="question-title" dangerouslySetInnerHTML={{ __html: getQuestionTitle(question) }} />
                                    </div>

                                    {question?.description && question?.description !== "<p><br></p>" && (
                                        <p dangerouslySetInnerHTML={{ __html: question?.description }} />
                                    )}

                                    <div className="form-group">
                                        <label htmlFor="">Jouw antwoord:</label>
                                        {getInput(question)}
                                        {errors[`answers.${question.id}`] && <div className="error">{errors[`answers.${question.id}`][0]}</div>}
                                    </div>
                                </div>
                            ))}
                        <div className="buttons_container">
                            <button className="btn kingkong btn-back" type="button" onClick={() => prevStep()}>
                                <img src={arrow_left_gray} alt="arrow" />
                                <span style={{ paddingLeft: "10px" }}>Terug</span>
                            </button>
                            <button type="submit" className="btn btn-primary kingkong">
                                <span>Volgende</span>
                                <img src={arrow_right_white} alt="arrow" />
                            </button>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
}
